// The welcome email lives in a single document in the InstructorWelcome
// collection: { subject, body, updated_at }.
export const WELCOME_COLLECTION = "InstructorWelcome";
export const WELCOME_DOC_ID = "template";
